var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTShirtDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4299_6287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06554 13.5906L-0.0585938 11.1226L2.84178 5.94928L7.44721 3.01367H7.50277C7.50277 4.11474 7.92988 5.1707 8.69012 5.94928C9.45037 6.72785 10.4815 7.16524 11.5566 7.16524C12.6318 7.16524 13.6629 6.72785 14.4232 5.94928C15.1834 5.1707 15.6105 4.11474 15.6105 3.01367H15.7605L20.2441 5.94928L22.0568 8.30213",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38281 11.5469V24.0469H11.7358",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 19.3594V24.0469H11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 13.1815C22.9981 13.233 23.1097 13.3086 23.2036 13.4038C23.2983 13.4982 23.3734 13.6105 23.4246 13.7343C23.4759 13.8581 23.5023 13.9908 23.5023 14.1249C23.5023 14.2589 23.4759 14.3917 23.4246 14.5154C23.3734 14.6392 23.2983 14.7515 23.2036 14.8459L20.1743 17.8927C20.0782 17.9852 19.965 18.0577 19.841 18.106C19.7202 18.1598 19.5895 18.1875 19.4573 18.1875C19.3252 18.1875 19.1945 18.1598 19.0736 18.106C18.9497 18.0577 18.8364 17.9852 18.7404 17.8927L15.711 14.8459C15.5209 14.6547 15.4141 14.3953 15.4141 14.1249C15.4141 13.8544 15.5209 13.595 15.711 13.4038C15.9012 13.2126 16.1591 13.1051 16.428 13.1051C16.6969 13.1051 16.9548 13.2126 17.1449 13.4038L18.4475 14.7241L18.4475 10.2187C18.4475 9.94937 18.5539 9.69105 18.7433 9.50059C18.9327 9.31013 19.1895 9.20312 19.4573 9.20312C19.7251 9.20312 19.982 9.31013 20.1713 9.50059C20.3607 9.69105 20.4671 9.94937 20.4671 10.2187L20.4671 14.7241L21.7697 13.4038C21.8636 13.3086 21.9753 13.233 22.0983 13.1815C22.2214 13.1299 22.3534 13.1034 22.4867 13.1034C22.62 13.1034 22.752 13.1299 22.875 13.1815Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4299_6287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirtDownArrow);
export default __webpack_public_path__ + "static/media/t-shirt-down-arrow.48fafe68f014fdc6f70819cd54b8113c.svg";
export { ForwardRef as ReactComponent };